const requestComments = {
  toggle: {
    comments: "Comments ({{count}})",
  },
  errors: {
    loadFailed: "Failed to load comments",
    addFailed: "Failed to add comment",
  },
  loading: "Loading comments...",
  empty: {
    noComments: "No comments yet.",
    startConversation: "Start the conversation!",
  },
  role: {
    researcher: "researcher",
    admin: "admin",
  },
  form: {
    placeholder: "Add a comment...",
    adding: "Adding...",
    addComment: "Add Comment",
  },
  disabledNotice:
    "Comments are only available for pending and approved requests.",
};

export default requestComments;
